import React from 'react';
import { Card } from "react-bootstrap";
import face_balazs_varga from "../../assets/img/face_balazs_varga.jpg";
import ShowMoreText from "react-show-more-text";
import proj_geom_repr from "../../assets/img/proj_geom_repr.png";

const Balazs_Varga_geom_repr = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_geom_repr} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_balazs_varga}
              /* ez a szöveg lesz majd a banneren */
              alt="Graph Neural Networks for Traffic Modelling"
            />{" "}
            <p className="text7">Balázs Varga</p>
            <br />
            <p className="text8">
              Research Fellow{" "}
            </p>
            <p className="text8">BME Traffic Lab </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            In traffic modelling and simulation, accurately representing the spatial geometry of a
            road network is often challenging, as intersection shapes typically need to be
            constructed or refined manually.
            <br />
            <br />
            This assignment has two main objectives:
            <br />
            <ol>
              <li>
                Given real-world intersection geometries represented as polygons, develop a
                transformation that maps them into a latent geometric space in which each
                intersection is represented by a simple shape, such as a rectangle. Applying
                such transformations piecewise across a network would produce a regular,
                grid-like representation of the road infrastructure.
              </li>
              <li>
                Use traffic simulation to assess the consistency and validity of the
                transformation. Investigate whether simulating traffic in the transformed space
                provides computational performance benefits that outweigh the additional cost
                of transforming the network and mapping the simulation results back to the
                original geometry.
              </li>
            </ol>


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balazs_Varga_geom_repr;